<template lang="pug">
  label.checkbox-field(:class="{ checked: value, crossing, disabled }" @mousedown="onMousedown")
    input.input(type="checkbox" :checked="value" @change="onChange")
    .box(:class="{ checked: value, error: !!error, small, white }")
    span.label(v-if="label" v-html="label" :class="{notColored: notColoredLabel}")
    span.error-message(v-if="error") {{ error }}
</template>

<script>
export default {
  props: {
    value: Boolean,
    label: String,
    error: String,
    small: Boolean,
    white: Boolean,
    notColoredLabel: Boolean,
    crossing: Boolean,
    disabled: Boolean,
  },
  name: 'BaseCheckbox',
  methods: {
    onChange(e) {
      this.$emit('input', e.target.checked);
      this.$emit('change', e.target.checked);
    },
    onMousedown(e) {
      if (e.ctrlKey || e.shiftKey) {
        // For non-IE browsers
        e.preventDefault();
      }

      this.$emit('toggle', {
        value: this.value, // not tested, may be wrong
        shift: e.shiftKey,
      });
    },
  },
};
</script>

<style scoped lang="scss">

.checkbox-field {
  display: grid;
  grid-template-columns: 18px auto;
  align-items: center;
  justify-items: start;
  gap: 10px;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .input {
    position: absolute;
    appearance: none;
  }

  .box {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: var(--color-super-light);
    border: 1px solid var(--color-super-light);
    border-radius: 3px;

    &.checked {
      border-color: var(--color-accent);
      background: url(../assets/img/svg/check.svg) center no-repeat var(--color-accent);
      background-size: 61% 50%;
    }

    &.error {
      border: 1px solid var(--color-red)
    }

    &.small {
      width: 14px;
      height: 14px;
    }

    &.white {
      &:not(.checked) {
        background: #fff;
        border-color: #D9DADA;
      }
    }
  }

  .label {
    min-width: 0;
  }

  .label::v-deep {
    grid-column: 2;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-middle-gray);

    &.notColored {
      color: inherit;
    }

    a {
      font-size: 12px;
      color: var(--color-accent) !important;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .error-message {
    grid-column: 2;
    grid-row: 2;
    color: var(--color-red);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.01em;
  }

  &.crossing {
    .label {
      color: #000;
    }

    &.checked .label {
      text-decoration-line: line-through;
      color: var(--color-middle-gray);
    }
  }
}
</style>
